import { NotificationPreferences as NotificationPreferencesModule } from '@vedicium/core-vue/build/modules/notifications';

export default class NotificationPreferences extends NotificationPreferencesModule {
  static uri = `/v2${NotificationPreferencesModule.uri}`;
}
